import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from 'lodash';

export class PlanningResourcesActionButtonNewCtrl implements IController {
  isDraft?: boolean;
  resources: any;
  selectedIds: Function;
  onAddToDraft: Function;
  onDispatch: Function;
  onRemove: Function;

  public actions: any;

  /* @ngInject */
  constructor(private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.actions = {};
  }

  onOpen($mdMenu, ev) {

    let lockedResources: boolean = false;
    let includedResources: boolean = false;
    let excludedResources: boolean = false;

    _.forEach(this.selectedIds, (resourceId) => {

      const resource = _.find(this.resources, (r) => {
        return r.id === resourceId;
      });

      if (!lockedResources && _.get(resource, 'locked')) {
        lockedResources = true;
      }

      if (!_.get(resource, 'excluded')) {
        includedResources = true;
      }

      if (!!_.get(resource, 'excluded')) {
        excludedResources = true;
      }
    })

    this.actions = {
      addToDraft: !includedResources && !!excludedResources,
      remove: !excludedResources && !lockedResources
    };

    this.$timeout(0).then(function () {
      $mdMenu.open(ev);
    });
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningResourcesActionButtonNew', {
    bindings: {
      isDraft: '<?',
      resources: '<',
      selectedIds: '<',
      onAddToDraft: '&',
      onDispatch: '&',
      onRemove: '&',
    },
    template: require('./planning-resources-action-button-new.html').default,
    controller: PlanningResourcesActionButtonNewCtrl
  });
